import { CollectItemStateTypes } from '~globals/types/enums';
import { PartnerCompanyItemFilterV2Base } from '~services/partnerCompany/types';

export const ITEM_KEY_ID = 'itemId';

export const DEFAULT_PAGINATION = {
  page: 1,
  sizePerPage: 50,
};

export const DEFAULT_COLLECT_ITEM_STATES: CollectItemStateTypes[] = [
  CollectItemStateTypes.ToCollect,
  CollectItemStateTypes.Validated,
];

export const DEFAULT_FILTERS_PAYLOAD: PartnerCompanyItemFilterV2Base = {
  routeCode: null,
  maxDeliveredDateTimeFrom: null,
  maxDeliveredDateTimeTo: null,
  includeWithoutMaxDeliveryDatetime: null,
  dateFrom: null,
  dateTo: null,
  giverCompanyId: null,
  driverId: null,
  assignedUserId: null,
  collectItemStateTypesId: DEFAULT_COLLECT_ITEM_STATES,
};
